var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1777_4308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.28125,
    y: 3.81824,
    width: 60.6864,
    height: 60.6864,
    rx: 9.48224,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 45.4214C15.7013 45.4214 13.1807 42.9008 13.1807 39.7915C13.1807 36.6821 15.7013 34.1615 18.8108 34.1615C21.9202 34.1615 24.4408 36.6821 24.4408 39.7915C24.4408 42.9008 21.9202 45.4214 18.8108 45.4214Z",
    stroke: "#6F52EA",
    strokeWidth: 3.55585
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.1087,
    y1: 39.5693,
    x2: 13.1087,
    y2: 26.383,
    stroke: "#6F52EA",
    strokeWidth: 3.40769,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4314 45.4214C51.5408 45.4214 54.0615 42.9008 54.0615 39.7915C54.0615 36.6821 51.5408 34.1615 48.4314 34.1615C45.322 34.1615 42.8014 36.6821 42.8014 39.7915C42.8014 42.9008 45.322 45.4214 48.4314 45.4214Z",
    stroke: "#6F52EA",
    strokeWidth: 3.55585
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.70384,
    y1: -1.70384,
    x2: 14.8901,
    y2: -1.70384,
    transform: "matrix(0 -1 -1 0 52.4297 41.2731)",
    stroke: "#6F52EA",
    strokeWidth: 3.40769,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.6261,
    cy: 25.8645,
    r: 3.55585,
    transform: "rotate(90 33.6261 25.8645)",
    stroke: "#6F52EA",
    strokeWidth: 2.37057
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.625 34.6059L33.625 44.9771",
    stroke: "#6F52EA",
    strokeWidth: 4.44481,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1777_4308",
    x: 0.208522,
    y: 0.74551,
    width: 69.9057,
    height: 69.9045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.53636,
    dy: 1.53636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30455
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4308",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverAppIcon);
export default __webpack_public_path__ + "static/media/driverAppIcon.44bb7ba73d3fde9fc6af00a963208cb8.svg";
export { ForwardRef as ReactComponent };